import Dropdown from './dropdown';
import DropdownButton from './dropdown-button';
Dropdown.Button = DropdownButton;
export default Dropdown;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/dropdown/index.js
// module id = 192
// module chunks = 3